export const inbox = {
  titles: {
    inbox: "Buzón de entrada",
    unifiedInbox: "Tu bandeja, unificada",
  },
  subtitles: {
    manageMessages: "Gestiona los mensajes de tus canales de reserva",
    unifiedDesc:
      "Aquí verás todas las conversaciones con tus huéspedes, sin importar si escriben desde Airbnb, Booking u otro canal.",
    subscribeHint:
      "Suscríbete para activar tu bandeja de entrada y simplificar tu comunicación.",
    planOnly:
      "Este módulo está disponible solo para planes {plans}.",
  },
  states: {
    notInstalledTitle: "Módulo de mensajes no instalado",
    notInstalledDesc:
      "Instala el módulo de mensajería para conectar con tus canales de reserva.",
    noChannelsTitle: "No tiene canales conectados",
    noChannelsDesc:
      "Para utilizar el módulo de mensajería, es necesario tener al menos un canal conectado (Booking.com, Airbnb).",
    noAccessTitle: "No tienes acceso al módulo de mensajes",
  },
  actions: {
    installModule: "Instalar módulo de mensajes",
    configureChannel: "Configurar canal",
  },
  toasts: {
    connectChannelRequiredTitle: "Conexión requerida",
    connectChannelRequiredBody:
      "Conecta al menos un canal de reserva para instalar el módulo de mensajes.",
  },
  errors: {
    notFoundPropertyOrUser: "No se ha encontrado la propiedad o el usuario.",
    channelConnectGeneric:
      "Error al conectar con el canal. Por favor intente nuevamente.",
    generateTokenError: "Error al generar token",
  },
};
